// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"RoadsideHero_swiper-slide-active__S3jAD","wrapper":"RoadsideHero_wrapper__O5rAu","title":"RoadsideHero_title__lx9-m"};